var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.28228",
      "client-types": "static-1.498",
      "conversations-internal-schema": "static-1.13425",
      "head-dlb": "static-1.5007",
      "hs-test-utils": "static-1.8352",
      "hubspot-url-utils": "static-1.4362",
      "HubStyleTokens": "static-2.11809",
      "I18n": "static-7.1677",
      "jasmine-runner": "static-1.6771",
      "quartz": "static-1.7480",
      "react": "static-7.198",
      "reselect": "static-3.12",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.504",
      "webpack-env": "static-1.54",
      "hub-http": "static-1.6535",
      "rpc-client-utils": "static-1.4987",
      "visitor-ui-component-library": "static-1.6472",
      "enviro": "static-4.455",
      "hs-promise-rejection-tracking": "static-1.5587",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "raven-hubspot": "static-1.6232",
      "moment": "static-3.75",
      "customer-data-email": "static-1.18546",
      "cv-backend-services": "static-1.1597",
      "immutable": "static-2.87",
      "immutable-less": "static-1.4970",
      "quartz-config": "static-1.1258",
      "quartz-core": "static-1.6699",
      "transmute": "static-2.97",
      "HeadJS": "static-2.799",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.8517",
      "framer-motion": "static-1.79",
      "hs-test-utils-bend-plugin": "static-1.3463",
      "msw": "static-1.39",
      "react-redux": "static-7.79",
      "redux": "static-4.80",
      "testing-library": "static-1.158",
      "foundations-theming": "static-1.4795",
      "i18n-data": "static-1.230",
      "metrics-js": "static-1.9959",
      "moment-timezone": "static-5.91",
      "react-utils": "static-2.5569",
      "jasmine": "static-4.4632",
      "csstype": "static-1.50",
      "hs-locale-management": "static-1.309",
      "bend-plugin-chirp-manifest": "static-1.397",
      "chirp-fetch": "static-1.2215",
      "quick-fetch": "static-1.4142",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.3213",
      "react-aria": "static-1.72",
      "styled-components": "static-2.99",
      "UIComponents": "static-3.8755",
      "visitor-ui-component-library-icons": "static-1.6283",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4976",
      "apollo-stack-hubspot": "static-3.94",
      "classnames": "static-2.10",
      "cssUtils": "static-1.942",
      "customer-data-objects": "static-1.8014",
      "customer-data-ui-utilities": "static-1.10152",
      "data-fetching-client": "static-1.9975",
      "FileManagerCore": "static-1.40034",
      "FileManagerLib": "static-1.40175",
      "foundations-assets": "static-1.5205",
      "graphql": "static-1.89",
      "hs-promise-utils": "static-1.5915",
      "hubspot-apollo-client": "static-1.5196",
      "icons": "static-2.686",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.113",
      "react-virtualized": "static-2.107",
      "salesImages": "static-1.583",
      "timezone-utils": "static-2.5564",
      "ui-gdpr-components": "static-1.10625",
      "ts-schema": "static-1.4308",
      "hs-lodash": "static-4.45",
      "immer": "static-1.101",
      "opentelemetry-fe-types": "static-1.94",
      "dispatcher": "static-1.143",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.885",
      "hubspotter-http": "static-1.4876",
      "mobile-manifest-mixins": "static-1.579",
      "module-federation": "static-1.33",
      "opentelemetry-fe": "static-1.469",
      "quartz-auth": "static-1.1155",
      "quartz-head": "static-1.1145",
      "quartz-i18n": "static-1.1155",
      "quartz-routing": "static-1.910",
      "quartz-test": "static-1.1155",
      "quartz-tracking": "static-1.859",
      "react-rhumb": "static-1.17041",
      "trellis-components": "static-1.2706",
      "ui-fonts": "static-1.1071",
      "usage-tracker-container": "static-1.7627",
      "usage-tracker-core": "static-1.7487",
      "bend-plugin-foundations-components": "static-1.4786",
      "floating-ui": "static-1.63",
      "foundations-theming-specialty": "static-1.2511",
      "hs-story-utils": "static-1.9745",
      "react-create-root-preference": "static-1.74",
      "tanstack-table": "static-1.61",
      "trellis-assets": "static-1.2687",
      "ui-images": "static-2.1254",
      "bender-build-tools": "static-1.3452",
      "bend-plugin-foundations-theming": "static-1.3278",
      "foundations-theming-base": "static-1.3780",
      "stylex": "static-1.41",
      "HubStyle": "static-2.12116",
      "sassPrefix": "static-1.211",
      "inbound-db-properties-service-client": "static-1.4066",
      "property-translator": "static-1.5715",
      "react-dnd-compat": "static-1.4936",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.9749",
      "breeze-artifacts-sdk": "static-1.397",
      "copilot-toolkit": "static-1.11869",
      "audio-components": "static-1.6366",
      "ContentUtils": "static-1.69150",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29834",
      "file-manager-components": "static-1.24535",
      "FileManagerImages": "static-1.37686",
      "html-to-image": "static-1.61",
      "immerable": "static-1.4469",
      "react-colorpicker": "static-2.10537",
      "redux-toolkit": "static-1.78",
      "ui-universal-auth": "static-1.9427",
      "urlinator": "static-1.4853",
      "usage-tracker": "static-1.7637",
      "video-components": "static-1.14173",
      "video-data-lib": "static-1.35829",
      "video-embed": "static-1.36663",
      "redux-thunk": "static-2.80",
      "hubspot-apollo-cache": "static-1.655",
      "opentelemetry-web": "static-1.15",
      "hub-http-shared-msw-handlers": "static-1.10643",
      "hubspotter-http-shared-msw-handlers": "static-1.10641",
      "usage-tracker-session-replay": "static-1.5323",
      "web-vitals": "static-1.15",
      "base-ui": "static-1.22",
      "react-day-picker": "static-1.10",
      "trellis-theming": "static-1.1296",
      "tanstack-virtual": "static-1.38",
      "stylex-utils": "static-1.145",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.23100",
      "customer-data-objects-ui-components": "static-1.13351",
      "sanitize": "static-1.4792",
      "sanitize-text": "static-1.8477",
      "breeze-engine-lib": "static-1.1779",
      "magpie-lib": "static-1.5772",
      "magpie-types": "static-1.5232",
      "simple-logging-lib": "static-1.3371",
      "superstore": "static-1.5078",
      "content-assistance-lib": "static-1.8221",
      "foundations-components-legacy": "static-1.1542",
      "cms-field-types": "static-1.5135",
      "content-icons-ui": "static-1.2384",
      "integrations-lib": "static-1.17071",
      "underscore": "static-1.8",
      "ui-addon-iframeable": "static-1.9397",
      "video-components-external": "static-1.12171",
      "unified-auth-core-lib": "static-1.1223",
      "social-insights-client-types": "static-1.22706",
      "SharedI18nStrings": "static-1.183",
      "outpost": "static-1.4473",
      "amplitude-session-replay-browser": "static-1.60",
      "markdown-it": "static-1.6",
      "atom": "static-1.5407",
      "avatar-components": "static-1.2803",
      "reference-resolvers": "static-1.8502",
      "breeze-engine-chat-components": "static-1.757",
      "breeze-engine-core": "static-1.1057",
      "ably": "static-2.2",
      "highlight.js": "static-1.86",
      "idb-keyval": "static-1.51",
      "reactive-lib": "static-1.1039",
      "ui-addon-video-player": "static-1.9024",
      "ui-coaching-tips": "static-1.29334",
      "flux-actions": "static-1.370",
      "frontend-preferences-client": "static-1.8242",
      "integrations-error-boundary-lib": "static-1.14486",
      "integrations-tracking-lib": "static-1.5929",
      "laboratory-lib": "static-3.7474",
      "native-integrations-shared-strings": "static-1.8098",
      "redux-observable": "static-1.75",
      "ReduxMessenger": "static-2.10691",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.11467",
      "ui-shepherd-react": "static-3.10590",
      "unified-auth": "static-1.941",
      "navigation-messaging": "static-1.8191",
      "content-media-composition-data-lib": "static-1.13270",
      "content-media-compositions": "static-2.17277",
      "media-bridge-lib": "static-1.19426",
      "fsm": "static-1.4071",
      "react-dlb": "static-1.89",
      "growth-onboarding-feedback-components": "static-1.6905",
      "universal-page-editor-lib": "static-1.3331",
      "foundations-components-test-utils": "static-1.6000",
      "adobe-sign-auth-lib": "static-1.490",
      "ads-unified-auth-lib": "static-1.1452",
      "generic-oauth-auth-lib": "static-1.69",
      "google-sheets-integration-lib": "static-1.1056",
      "microsoft-drive-auth-lib": "static-1.172",
      "surveymonkey-integration-lib": "static-1.514",
      "slack-ui-library": "static-1.10718",
      "js-cookie": "static-1.18",
      "crm-record-cards-service-types": "static-1.3796",
      "framework-data-schema-resolvers": "static-1.7212",
      "location-customization-utils-lib": "static-1.10125",
      "batch-promise": "static-1.1864",
      "conditional-properties-service-client": "static-1.4029",
      "crm-pipelines-api-client-types": "static-1.4362",
      "fdsr-migration-layer": "static-1.331",
      "framework-builder-read-service-client": "static-1.4235",
      "framework-data-schema-quick-fetch": "static-1.7117",
      "inbound-db-meta-service-client": "static-1.3718",
      "multi-currency-client-types": "static-1.3922",
      "persist-promise": "static-1.4021"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.28228",
      "client-types": "/client-types/static-1.498",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13425",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-test-utils": "/hs-test-utils/static-1.8352",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4362",
      "HubStyleTokens": "/HubStyleTokens/static-2.11809",
      "I18n": "/I18n/static-7.1677",
      "jasmine-runner": "/jasmine-runner/static-1.6771",
      "quartz": "/quartz/static-1.7480",
      "react": "/react/static-7.198",
      "reselect": "/reselect/static-3.12",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.504",
      "webpack-env": "/webpack-env/static-1.54",
      "hub-http": "/hub-http/static-1.6535",
      "rpc-client-utils": "/rpc-client-utils/static-1.4987",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6472",
      "enviro": "/enviro/static-4.455",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "moment": "/moment/static-3.75",
      "customer-data-email": "/customer-data-email/static-1.18546",
      "cv-backend-services": "/cv-backend-services/static-1.1597",
      "immutable": "/immutable/static-2.87",
      "immutable-less": "/immutable-less/static-1.4970",
      "quartz-config": "/quartz-config/static-1.1258",
      "quartz-core": "/quartz-core/static-1.6699",
      "transmute": "/transmute/static-2.97",
      "HeadJS": "/HeadJS/static-2.799",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.8517",
      "framer-motion": "/framer-motion/static-1.79",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3463",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.79",
      "redux": "/redux/static-4.80",
      "testing-library": "/testing-library/static-1.158",
      "foundations-theming": "/foundations-theming/static-1.4795",
      "i18n-data": "/i18n-data/static-1.230",
      "metrics-js": "/metrics-js/static-1.9959",
      "moment-timezone": "/moment-timezone/static-5.91",
      "react-utils": "/react-utils/static-2.5569",
      "jasmine": "/jasmine/static-4.4632",
      "csstype": "/csstype/static-1.50",
      "hs-locale-management": "/hs-locale-management/static-1.309",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.397",
      "chirp-fetch": "/chirp-fetch/static-1.2215",
      "quick-fetch": "/quick-fetch/static-1.4142",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.3213",
      "react-aria": "/react-aria/static-1.72",
      "styled-components": "/styled-components/static-2.99",
      "UIComponents": "/UIComponents/static-3.8755",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6283",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4976",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.942",
      "customer-data-objects": "/customer-data-objects/static-1.8014",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10152",
      "data-fetching-client": "/data-fetching-client/static-1.9975",
      "FileManagerCore": "/FileManagerCore/static-1.40034",
      "FileManagerLib": "/FileManagerLib/static-1.40175",
      "foundations-assets": "/foundations-assets/static-1.5205",
      "graphql": "/graphql/static-1.89",
      "hs-promise-utils": "/hs-promise-utils/static-1.5915",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5196",
      "icons": "/icons/static-2.686",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.113",
      "react-virtualized": "/react-virtualized/static-2.107",
      "salesImages": "/salesImages/static-1.583",
      "timezone-utils": "/timezone-utils/static-2.5564",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
      "ts-schema": "/ts-schema/static-1.4308",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.101",
      "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.94",
      "dispatcher": "/dispatcher/static-1.143",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.885",
      "hubspotter-http": "/hubspotter-http/static-1.4876",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.579",
      "module-federation": "/module-federation/static-1.33",
      "opentelemetry-fe": "/opentelemetry-fe/static-1.469",
      "quartz-auth": "/quartz-auth/static-1.1155",
      "quartz-head": "/quartz-head/static-1.1145",
      "quartz-i18n": "/quartz-i18n/static-1.1155",
      "quartz-routing": "/quartz-routing/static-1.910",
      "quartz-test": "/quartz-test/static-1.1155",
      "quartz-tracking": "/quartz-tracking/static-1.859",
      "react-rhumb": "/react-rhumb/static-1.17041",
      "trellis-components": "/trellis-components/static-1.2706",
      "ui-fonts": "/ui-fonts/static-1.1071",
      "usage-tracker-container": "/usage-tracker-container/static-1.7627",
      "usage-tracker-core": "/usage-tracker-core/static-1.7487",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4786",
      "floating-ui": "/floating-ui/static-1.63",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2511",
      "hs-story-utils": "/hs-story-utils/static-1.9745",
      "react-create-root-preference": "/react-create-root-preference/static-1.74",
      "tanstack-table": "/tanstack-table/static-1.61",
      "trellis-assets": "/trellis-assets/static-1.2687",
      "ui-images": "/ui-images/static-2.1254",
      "bender-build-tools": "/bender-build-tools/static-1.3452",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3278",
      "foundations-theming-base": "/foundations-theming-base/static-1.3780",
      "stylex": "/stylex/static-1.41",
      "HubStyle": "/HubStyle/static-2.12116",
      "sassPrefix": "/sassPrefix/static-1.211",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4066",
      "property-translator": "/property-translator/static-1.5715",
      "react-dnd-compat": "/react-dnd-compat/static-1.4936",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9749",
      "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.397",
      "copilot-toolkit": "/copilot-toolkit/static-1.11869",
      "audio-components": "/audio-components/static-1.6366",
      "ContentUtils": "/ContentUtils/static-1.69150",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29834",
      "file-manager-components": "/file-manager-components/static-1.24535",
      "FileManagerImages": "/FileManagerImages/static-1.37686",
      "html-to-image": "/html-to-image/static-1.61",
      "immerable": "/immerable/static-1.4469",
      "react-colorpicker": "/react-colorpicker/static-2.10537",
      "redux-toolkit": "/redux-toolkit/static-1.78",
      "ui-universal-auth": "/ui-universal-auth/static-1.9427",
      "urlinator": "/urlinator/static-1.4853",
      "usage-tracker": "/usage-tracker/static-1.7637",
      "video-components": "/video-components/static-1.14173",
      "video-data-lib": "/video-data-lib/static-1.35829",
      "video-embed": "/video-embed/static-1.36663",
      "redux-thunk": "/redux-thunk/static-2.80",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.655",
      "opentelemetry-web": "/opentelemetry-web/static-1.15",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10643",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10641",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
      "web-vitals": "/web-vitals/static-1.15",
      "base-ui": "/base-ui/static-1.22",
      "react-day-picker": "/react-day-picker/static-1.10",
      "trellis-theming": "/trellis-theming/static-1.1296",
      "tanstack-virtual": "/tanstack-virtual/static-1.38",
      "stylex-utils": "/stylex-utils/static-1.145",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.23100",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13351",
      "sanitize": "/sanitize/static-1.4792",
      "sanitize-text": "/sanitize-text/static-1.8477",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.1779",
      "magpie-lib": "/magpie-lib/static-1.5772",
      "magpie-types": "/magpie-types/static-1.5232",
      "simple-logging-lib": "/simple-logging-lib/static-1.3371",
      "superstore": "/superstore/static-1.5078",
      "content-assistance-lib": "/content-assistance-lib/static-1.8221",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1542",
      "cms-field-types": "/cms-field-types/static-1.5135",
      "content-icons-ui": "/content-icons-ui/static-1.2384",
      "integrations-lib": "/integrations-lib/static-1.17071",
      "underscore": "/underscore/static-1.8",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9397",
      "video-components-external": "/video-components-external/static-1.12171",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1223",
      "social-insights-client-types": "/social-insights-client-types/static-1.22706",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
      "outpost": "/outpost/static-1.4473",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "markdown-it": "/markdown-it/static-1.6",
      "atom": "/atom/static-1.5407",
      "avatar-components": "/avatar-components/static-1.2803",
      "reference-resolvers": "/reference-resolvers/static-1.8502",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.757",
      "breeze-engine-core": "/breeze-engine-core/static-1.1057",
      "ably": "/ably/static-2.2",
      "highlight.js": "/highlight.js/static-1.86",
      "idb-keyval": "/idb-keyval/static-1.51",
      "reactive-lib": "/reactive-lib/static-1.1039",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.9024",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29334",
      "flux-actions": "/flux-actions/static-1.370",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8242",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14486",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5929",
      "laboratory-lib": "/laboratory-lib/static-3.7474",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8098",
      "redux-observable": "/redux-observable/static-1.75",
      "ReduxMessenger": "/ReduxMessenger/static-2.10691",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11467",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10590",
      "unified-auth": "/unified-auth/static-1.941",
      "navigation-messaging": "/navigation-messaging/static-1.8191",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13270",
      "content-media-compositions": "/content-media-compositions/static-2.17277",
      "media-bridge-lib": "/media-bridge-lib/static-1.19426",
      "fsm": "/fsm/static-1.4071",
      "react-dlb": "/react-dlb/static-1.89",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6905",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3331",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6000",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.490",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1452",
      "generic-oauth-auth-lib": "/generic-oauth-auth-lib/static-1.69",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1056",
      "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.172",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.514",
      "slack-ui-library": "/slack-ui-library/static-1.10718",
      "js-cookie": "/js-cookie/static-1.18",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7212",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10125",
      "batch-promise": "/batch-promise/static-1.1864",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4029",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4362",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.331",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4235",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7117",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3922",
      "persist-promise": "/persist-promise/static-1.4021"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.28228",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};